'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Badge.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A textual badge.
 */
var Badge = function Badge(_ref) {
  var text = _ref.text,
    margin = _ref.margin,
    size = _ref.size,
    success = _ref.success;
  var badgeClass = (0, _classnames2.default)('c-badge', {
    'c-badge--default': !success,
    'c-badge--success': success,
    'c-badge--m-right': margin,
    'c-badge--small': size === 'small'
  });
  return _react2.default.createElement('div', {
    className: badgeClass
  }, text);
};
Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Required text to be displayed in the badge */
  text: _propTypes2.default.string.isRequired,
  /** Adds margin to the right side */
  margin: _propTypes2.default.bool,
  /** Sets the size of the badge */
  size: _propTypes2.default.oneOf(['small']),
  /** Additional success boolean */
  success: _propTypes2.default.bool
} : {};
Badge.defaultProps = {
  success: false
};
exports.default = Badge;